import React from 'react'
 
export default function BrandNewInfo({st}) {
  return (
    <div>
      {`released on ${st}`}
    </div>
  )
}
